module.exports = __webpack_public_path__ + "img/Last image OOBE German.7ce40db0.png";